import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/category";
  // const { products, refetch } = useProduct();
  console.log("Initial Data", initialData);

  // Menambahkan state untuk menyimpan products
  const [formData, setFormData] = useState({
    name: "",
    color: "#ffffff",
    type: "",
    icon: "",
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "categorys"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "categorys"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Gunakan hook untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // Jika initialData tersedia, isi form untuk update
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }
  , [initialData]);
  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/*  Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder=" Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>
        {/* type */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="type"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Type:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.type && "is-invalid"
              )}
              id="type"
              placeholder="Type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.type && (
              <div className="invalid-feedback">{formError.type}</div>
            )}
          </div>
        </div>

        {/* Color Picker */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="color"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Color:
          </label>
          <div className="col-sm-8">
            <input
              type="color"
              className="form-control"
              id="color"
              name="color"
              value={formData.color}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        {/* Icon */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="icon"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Icon:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.icon && "is-invalid"
              )}
              id="icon"
              placeholder="Icon"
              name="icon"
              value={formData.icon}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.icon && (
              <div className="invalid-feedback">{formError.icon}</div>
            )}
          </div>
          </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Category" : "Create Category"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
